module.exports = __webpack_public_path__ + "img/master_of_elements_small.dbd9cae0.png";